import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'

@Component({
  standalone: false,
  selector: 'vs-bulk-quote-confirmation',
  templateUrl: './bulk-quote-confirmation.component.html',
  styleUrls: ['./bulk-quote-confirmation.component.scss'],
})
export class BulkQuoteConfirmationComponent implements OnInit {
  constructor(private router: Router) {}
  goToQuote() {
    this.router.navigate(['quote/cart'])
  }
  ngOnInit(): void {}
}
